import { render, staticRenderFns } from "./VideosCreate.vue?vue&type=template&id=1834ede8&scoped=true"
import script from "./VideosCreate.vue?vue&type=script&lang=js"
export * from "./VideosCreate.vue?vue&type=script&lang=js"
import style0 from "./VideosCreate.vue?vue&type=style&index=0&id=1834ede8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834ede8",
  null
  
)

export default component.exports